import useTimeZoneClock from 'hooks/useTimeZoneClock';
import { getBackgroundStyle } from 'components/common/TableColor';
import moment from 'moment-timezone';
import React from 'react'
import { SubmitButton } from './common/buttons/SubmitButton';
import { DEFAULT_TIMEZONE } from 'helpers/timezoneHelper';

const formatDuration = (seconds) => {
    if (!seconds && seconds !== 0) return 'N/A';
    const h = Math.floor(seconds / 3600);
    const m = Math.floor((seconds % 3600) / 60);
    const s = seconds % 60;
    return [h, m, s].map(v => String(v).padStart(2, '0')).join(':');
};

const AppointmentDetailsTable = ({ item }) => {
    const timeZone = useTimeZoneClock(item?.datetime);
    const formattedDate = moment(timeZone).format('MMMM DD YYYY');
    const formattedTime = moment(timeZone).format('hh:mm A');

    const InfoRow = ({ label, value, toLowerCase = "" }) => (
        <div className='row_detail_tab'>
            <div className='label_view'><strong>{label}</strong></div>
            <div className={`detail_view ${toLowerCase}`}>{value || 'N/A'}</div>
        </div>
    );
    const rowDash1Style = {
        display: 'flex',
        alignItems: 'normal',
        width: '100%',
        gap: '1rem'
    };
    const rowDash2Style = {
        display: 'block',
        alignItems: 'normal',
        width: '100%',
        gap: '1rem'
    };
    const marginTopZero = {
        marginTop: 0
    };

    console.log("item", item)
    return (
        <div className="Table_data_show Table_data_show1 p-0 overflow-auto">



            <div className="card_table" style={marginTopZero}>

                <div className="Table_data_show Table_data_show1 pt-0 ">
                    <table class="bg-info-secondary table" style={getBackgroundStyle(item?.status)}>
                        <tbody>
                            <tr>
                                <td className="bg-info-secondary" style={{ ...getBackgroundStyle(item?.status), width: "40%" }}>Status: </td>
                                <td className="bg-info-secondary capitalize-status" style={getBackgroundStyle(item?.status)}>{item?.status}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                {/* <div className="Table_data_show Table_data_show1 pt-0 ">
                           <table class="bg-primary-secondary table">
                               <tbody>
                                   <tr>
                                       <td class="bg-primary-secondary" style={{ width: "40%" }}>Patient Name: </td>
                                       <td class="bg-primary-secondary">{item.appointment_details?.patient?.patient_name  || 'N/A'}</td>
                                   </tr>
                                   <tr>
                                       <td class="bg-primary-secondary" style={{ width: "40%" }}>MRN:</td>
                                       <td class="bg-primary-secondary">{item.appointment_details?.patient?.mrn_number  || 'N/A'}</td>
                                   </tr>
                                   <tr>
                                       <td class="bg-primary-secondary" style={{ width: "40%" }}>DOB:</td>
                                       <td class="bg-primary-secondary">{item.appointment_details?.patient?.birth_date  || 'N/A'}</td>
                                   </tr>
                                   <tr>
                                       <td class="bg-primary-secondary" style={{ width: "40%" }}>Medicaid ID:</td>
                                       <td class="bg-primary-secondary">{item.appointment_details?.patient?.medicaid_id  || 'N/A'}</td>
                                   </tr>
                                   <tr>
                                       <td class="bg-primary-secondary" style={{ width: "40%" }}>Health Plan:</td>
                                       <td class="bg-primary-secondary">{item.appointment_details?.patient?.medicaid_plan  || 'N/A'}</td>
                                   </tr>
                               </tbody>
                           </table>
                       </div> */}
                <div className="Table_data_show Table_data_show1 pt-0 ">
                    <table class="bg-primary-secondary table">
                        <tbody>
                            <tr>
                                <td class="bg-primary-secondary" style={{ width: "40%" }}>Requester First Name: </td>
                                <td class="bg-primary-secondary">{item.appointment_details?.requester_name || 'N/A'}</td>
                            </tr>
                            <tr>
                                <td class="bg-primary-secondary" style={{ width: "40%" }}>Requester Email: </td>
                                <td class="bg-primary-secondary" toLowerCase={'text-lowercase'}>{item.appointment_details?.requester_email || 'N/A'}</td>
                            </tr>
                            {/* <tr>
                                       <td class="bg-primary-secondary" style={{ width: "40%" }}>Requester Phone:</td>
                                       <td class="bg-primary-secondary">{item.appointment_details?.requester_phone || 'N/A'}</td>
                                   </tr> */}
                            <tr>
                                <td class="bg-primary-secondary" style={{ width: "40%" }}>Requester Callback Number:</td>
                                <td class="bg-primary-secondary">{item.appointment_details?.requester_phone || 'N/A'}</td>
                            </tr>

                            <tr>
                                <td class="bg-primary-secondary" style={{ width: "40%" }}>Requester Pin Code:</td>
                                <td class="bg-primary-secondary">{item.appointment_details?.pincode?.name || 'N/A'}</td>
                            </tr>
                            <tr>
                                <td class="bg-primary-secondary" style={{ width: "40%" }}>LEP Name:</td>
                                <td class="bg-primary-secondary">{item.appointment_details?.lep_name || 'N/A'}</td>
                            </tr>
                            <tr>
                                <td class="bg-primary-secondary" style={{ width: "40%" }}>Economic services:</td>
                                <td class="bg-primary-secondary">{item.appointment_details?.requester_economic_service || 'N/A'}</td>
                            </tr>
                            <tr>
                                <td className="bg-primary-secondary" style={{ width: "20%" }}>Appointment Notes:</td>
                                <td colSpan={4} className="bg-primary-secondary">{item?.appointment_details?.special_instruction || 'N/A'}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>



            {/* <div className="card_table" style={marginTopZero}>
                <div className="Table_data_show Table_data_show1 pt-0">
                    <table className="bg-primary-secondary table">
                        <tbody>

                            <tr>
                                <td className="bg-primary-secondary">DNC Reason:</td>
                                <td colSpan={2} className="bg-primary-secondary">{item?.appointment_details?.dnc_reason || 'N/A'}</td>
                                <td className="bg-primary-secondary">CNC Reason:</td>
                                <td colSpan={2} className="bg-primary-secondary">{item?.appointment_details?.cnc_reason || 'N/A'}</td>
                            </tr>
                            <tr>
                                <td className="bg-primary-secondary">Cancel reason:</td>
                                <td className="bg-primary-secondary" colSpan={2}>{item?.appointment_details?.cancel_reason || 'N/A'}</td>
                                <td className="bg-primary-secondary">Notes:</td>
                                <td className="bg-primary-secondary" colSpan={2}>{item?.appointment_assign?.notes || 'N/A'}</td>
                            </tr>
                            <tr>
                                <td className="bg-primary-secondary">Interpreter Joined At:</td>
                                <td className="bg-primary-secondary" colSpan={2}>
                                    {item?.appointment_assign?.interpreter_joined_at
                                        ? item.appointment_assign.interpreter_joined_at.split(',').map((t, i) => (
                                            <div key={i}>{moment.tz(t.trim(), DEFAULT_TIMEZONE).format('MMM D, YYYY HH:mm:ss')}</div>
                                        ))
                                        : 'N/A'}
                                </td>
                                <td className="bg-primary-secondary">Interpreter Left At:</td>
                                <td className="bg-primary-secondary" colSpan={2}>
                                    {item?.appointment_assign?.interpreter_left_at
                                        ? item.appointment_assign.interpreter_left_at.split(',').map((t, i) => (
                                            <div key={i}>{moment.tz(t.trim(), DEFAULT_TIMEZONE).format('MMM D, YYYY HH:mm:ss')}</div>
                                        ))
                                        : 'N/A'}
                                </td>
                            </tr>
                            <tr>
                                <td className="bg-primary-secondary">Interpreter Total Duration:</td>
                                <td className="bg-primary-secondary" colSpan={6}>{formatDuration(item?.appointment_assign?.interpreter_total_duration)}</td>
                            </tr>
                            <tr>
                                <td className="bg-primary-secondary">Actual Start Time:</td>
                                <td className="bg-primary-secondary" colSpan={2}>
                                    {item?.appointment_details?.actual_start_time
                                        ? moment.tz(item.appointment_details.actual_start_time, DEFAULT_TIMEZONE).format('MMM D, YYYY HH:mm:ss')
                                        : 'N/A'}
                                </td>
                                <td className="bg-primary-secondary">Actual End Time:</td>
                                <td className="bg-primary-secondary" colSpan={2}>
                                    {item?.appointment_details?.actual_end_time
                                        ? moment.tz(item.appointment_details.actual_end_time, DEFAULT_TIMEZONE).format('MMM D, YYYY HH:mm:ss')
                                        : 'N/A'}
                                </td>
                            </tr>
                            <tr>
                                <td className="bg-primary-secondary">Rejoined At:</td>
                                <td className="bg-primary-secondary" colSpan={2}>
                                    {item?.appointment_details?.rejoined_at
                                        ? item.appointment_details.rejoined_at.split(',').map((t, i) => (
                                            <div key={i}>{moment.tz(t.trim(), DEFAULT_TIMEZONE).format('MMM D, YYYY HH:mm:ss')}</div>
                                        ))
                                        : 'N/A'}
                                </td>
                                <td className="bg-primary-secondary">Left At:</td>
                                <td className="bg-primary-secondary" colSpan={2}>
                                    {item?.appointment_details?.left_at
                                        ? item.appointment_details.left_at.split(',').map((t, i) => (
                                            <div key={i}>{moment.tz(t.trim(), DEFAULT_TIMEZONE).format('MMM D, YYYY HH:mm:ss')}</div>
                                        ))
                                        : 'N/A'}
                                </td>
                            </tr>
                            <tr>
                                <td className="bg-primary-secondary">Actual Duration:</td>
                                <td className="bg-primary-secondary" colSpan={6}>{formatDuration(item?.appointment_details?.actual_total_duration)}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div> */}

        </div>
    );
};

export default AppointmentDetailsTable;





